/**
 * Available permissions in the system
 * These are used for role-based access control throughout the application
 */
export const AVAILABLE_PERMISSIONS = [
  "view_dashboard",
  "user_management",
  "analytics_view",
  "reports_management",
  "application_management",
  "customer_support",
  "financial_data",
  "system_admin",
  "updates_management",
  "Documents_management",
  "landing_pages_control",
  "social_links",
  "FAQs",
  "zones_&_subzones",
  "upcoming_subscriptions",
  "view_notifications",
  "news_letter_management",
  "view_audit_trail",
  "approve_reject_expenses",
  "edit_user_status",
  "wallet_management",
  "wallet_commission_settings",
  "wallet_transaction_history",
] as const;

export type Permission = (typeof AVAILABLE_PERMISSIONS)[number];
